export const CHAINS_PER_MILE = 80;
export const YARDS_PER_CHAIN = 22;
export const METRES_PER_CHAIN = 20.1186;
